/**
 * Client-side SSH public-key validation. This is a UX aid only — the server is
 * authoritative and performs the real parsing/validation.
 *
 * Accepts the common OpenSSH public-key prefixes: ed25519, rsa, dss, ecdsa
 * (`ecdsa-sha2-*`) and FIDO/security-key variants (`sk-ssh-*`). A key must have
 * an algorithm prefix followed by a space and the base64 key body.
 */
const SSH_KEY_PREFIX = /^(ssh-(ed25519|rsa|dss)|ecdsa-sha2-\S+|sk-ssh-\S+) /

/**
 * Returns true when the given string looks like a valid SSH public key.
 * Trims surrounding whitespace before checking.
 */
export function isValidSshKey(key: string): boolean {
  return SSH_KEY_PREFIX.test(key.trim())
}
